<template>
  <div class="tmb-msi">
    <div class="tab-box">
      <van-tabs
        v-model="active"
        background="none"
        color="#4B84FF"
        line-width="20"
        title-active-color="#2F354D"
        title-inactive-color="#9095A7"
        @change="handleTabs"
      >
        <van-tab v-for="(item, index) in tab" :title="item" :key="index" />
      </van-tabs>
    </div>
    <div class="tmb" v-show="active == 0">
      <TMB :tmbData="tmbData" />
    </div>
    <div class="tmb" v-show="active == 1">
      <MSI :msiData="msiData" />
    </div>
  </div>
</template>
<script>
import TMB from "../reportQuery/components/tmbMsi/TMB.vue";
import MSI from "../reportQuery/components/tmbMsi/MSI.vue";
import { tmbDetails, msiDetails } from "@/api/reportQuery";
import { mapState } from "vuex";
export default {
  name: "tmb-msi",
  components: {
    TMB,
    MSI,
  },
  data() {
    return {
      active: 0,
      msiData: {},
      tmbData: {},
      tab: [],
    };
  },
  created() {},
  computed: {
    ...mapState("embry", ["publicParams"]),
  },

  methods: {
    async getTmb(fname, fid) {
      try {
        console.log(tmbDetails);
        let { data } = await tmbDetails({
          labOriginalSampleNo: fname,
          productId: fid,
        });
        this.tmbData = {
          result: data.tmbValue,
          resultText: data.tmbSummary2,
          jxText: data.tmb,
          careful: "",
        };
      } catch (error) {}
    },
    async getMsi(fname, fid) {
      try {
        let { data } = await msiDetails({
          labOriginalSampleNo: fname,
          productId: fid,
        });
        console.log(data);
        this.msiData = {
          result: data.msiStatus,
          resultText: data.msiSummary2,
          jxText: data.msi,
          careful: "",
        };
      } catch (error) {}
    },
    handleTabs(val) {},
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      sessionStorage.setItem("tab", JSON.stringify(['TMB','MSI']));

      // let tab = JSON.parse(vm.$route.query.tab);
      let tab = JSON.parse(sessionStorage.getItem('tab'));
      tab.forEach((item) => {
        if (item == "TMB") {
          vm.getTmb(
            vm.$route.query.fname,
            vm.$route.query.fid
          );
        }
        if (item == "MSI") {
          vm.getMsi(
            vm.$route.query.fname,
            vm.$route.query.fid
          );
        }
      });
      vm.tab = tab;
    });
  },
};
</script>
<style lang="less" scoped>
.tmb-msi {
  padding: 10px 16px;

  /deep/.van-tabs--line .van-tabs__wrap {
    height: 30px;
  }
  /deep/.van-tab--active .van-tab__text--ellipsis {
    // font-size: 15px;
    font-family: @family;
    font-weight: 500;
    color: #2f354d;
  }
  .tab-box {
    height: 40px;
    margin-bottom: 10px;
    background: transparent;
    // box-sizing: border-box;
    // border-top-left-radius: 10px;
    // border-top-right-radius: 10px;
  }
}
</style>
